import ScrollReveal from "./ScrollReveal";
import usePrefersReducedMotion from "../hooks/usePrefersReducedMotion";
import { JOURNEY_STAGES, type JourneyStage } from "../data/journeyStages";

function StageCard({ stage }: { stage: JourneyStage }) {
  return (
    <div className="h-full rounded-2xl bg-white p-6 shadow-sm ring-1 ring-ocean-900/5">
      <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-400/15 text-teal-500">
        <stage.icon className="h-5 w-5" strokeWidth={1.5} />
      </div>
      <span className="mt-3 block text-xs font-semibold uppercase tracking-widest text-teal-700">
        {stage.indicatorLabel}
      </span>
      <h3 className="mt-1 font-display text-lg font-semibold text-ocean-950">{stage.name}</h3>
      <p className="mt-1.5 text-sm leading-relaxed text-ocean-800/70">{stage.description}</p>
    </div>
  );
}

/**
 * Scroll-driven reveal via ScrollReveal's whileInView (no GSAP needed).
 * prefers-reduced-motion -> a plain static grid, all stages visible at
 * once, no entrance animation — the AC's "simplified static step-by-step
 * version," not just a smaller motion duration.
 */
export default function JourneyVisualizer() {
  const reducedMotion = usePrefersReducedMotion();

  if (reducedMotion) {
    return (
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {JOURNEY_STAGES.map((stage) => (
          <StageCard key={stage.id} stage={stage} />
        ))}
      </div>
    );
  }

  return (
    <div className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-6 [scrollbar-width:thin]">
      {JOURNEY_STAGES.map((stage, i) => (
        <ScrollReveal key={stage.id} delay={i * 0.1} className="w-64 shrink-0 snap-start">
          <StageCard stage={stage} />
        </ScrollReveal>
      ))}
    </div>
  );
}
